<template>
  <div class="submitBox">
    <el-form label-position="left" label-width="120px" :model="formList">
      <el-form-item label="预约的活动室" required>
        <el-input v-model="formList.urlName" disabled></el-input>
      </el-form-item>
      <el-form-item label="预定时间" v-if="formList.type == '1'" required>
        <el-select
          v-model="selectedTime"
          multiple
          collapse-tags
          @change="handleChange($event)"
          placeholder="可多选,只可选择相邻时间"
          :multiple-limit='3'
        >
          <el-option
            v-for="option in options"
            :key="option.value"
            :value="option.label"
            :disabled="option.disable"
          >
            {{ option.label }}
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预定时间" required v-if="formList.type == '2'">
        <el-input v-model="formList.region" disabled></el-input>
      </el-form-item>
      <el-form-item label="活动区域" required>
        <el-input v-model="formList.activityAreaName" disabled></el-input>
      </el-form-item>
      <el-form-item label="预约人" required>
        <el-input v-model="formList.name" disabled></el-input>
      </el-form-item>
      <el-form-item label="参与人">
        <div
          @click="changeDep"
          :class="{
            changePop: !formList.namelist,
            changePop1: formList.namelist,
          }"
        >
          {{ formList.namelist ? formList.namelist : "请选择" }}
        </div>
        <!-- <el-input
          placeholder="请选择"
          @focus="changeDep"
          v-model="formList.namelist"
          :readonly="true"
        ></el-input> -->
      </el-form-item>
    </el-form>
    <div v-if="appPeople">
      <div class="menu"></div>
      <div class="choose">
        审批流程（已由管理员预设不可修改审批人和删除抄送人）
      </div>
      <div>
        <div class="appPeople">审批人</div>
        <div class="app_item">
          <div class="approve" v-for="item in approver" :key="item.approveCode">
            <img :src="item.icon" alt="" /> {{ item.approveName }}
          </div>
        </div>
      </div>
      <div v-if="appmake.length > 0">
        <div class="makePeople">抄送人</div>
        <div class="makeItem">
          <div class="make" v-for="item in appmake" :key="item.approveCode">
            <img :src="item.icon" alt="" />{{ item.approveName }}
          </div>
          <!-- <div class="iconPlus">
              <i class="el-icon-plus" @click="depamentDialogTwo = true"></i>
            </div> -->
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="submit">
        <el-button class="cancelBtn" @click="cancel"> 取消 </el-button>
        <el-button class="submitBtn" @click="submit" v-loading="btnLoading">
          提交
        </el-button>
      </div>
    </div>
    <depamentDialog
      :visible.sync="depamentDialog"
      @changeQuery="changeQuery"
      :userNames="userNames"
      :treeList="treeList"
    />
    <!-- <depamentDialogTwo
      :visible.sync="depamentDialogTwo"
      @changeQuery="changeQueryTwo"
      :userNames="userNamesTwo"
    /> -->
  </div>
</template>

<script>
import moment from "moment";
import depamentDialog from "./depamentDialog.vue";
// import depamentDialogTwo from "./depamentDialogTwo.vue";
import api from "@/apis/reservation";
import { uncompress } from "@/utils/tools";
// import rw from '@/apis/rw';

export default {
  name: "upload",
  props: [
    // "visible",
    // "ctimeMenuList",
    // "startTime",
    // "endTime",
    // "valueMonth",
    // "cText",
    // "urlName",
    // "urlId",
    // "userID",
    // "userNa",
    // "time",
    // "type",
  ],
  components: {
    depamentDialog,
    // depamentDialogTwo,
  },
  // props: {
  //   visible: {
  //     type: Boolean,
  //     default: false,
  //   },
  //   ctimeMenuList: {
  //     type: Object,
  //     default: () => {},
  //   },
  // },
  data() {
    return {
      dialogVisible: false,
      list: [],
      formList: {},
      depamentDialog: false,
      depamentDialogTwo: false,
      userNames: [],
      userNamesTwo: [],
      st: "",
      en: "",
      appPeople: false,
      approver: [],
      appmake: [],
      btnLoading: false,
      options: [
        { label: "08:00-08:30", disable: false, value: "08:00", ctime: "8" },
        { label: "08:30-09:00", disable: false, value: "08:30", ctime: "8:30" },
        { label: "09:00-09:30", disable: false, value: "09:00", ctime: "9" },
        { label: "09:30-10:00", disable: false, value: "09:30", ctime: "9:30" },
        { label: "10:00-10:30", disable: false, value: "10:00", ctime: "10" },
        {
          label: "10:30-11:00",
          disable: false,
          value: "10:30",
          ctime: "10:30",
        },
        { label: "11:00-11:30", disable: false, value: "11:00", ctime: "11" },
        {
          label: "11:30-12:00",
          disable: false,
          value: "11:30",
          ctime: "11:30",
        },
        { label: "12:00-12:30", disable: false, value: "12:00", ctime: "12" },
        {
          label: "12:30-13:00",
          disable: false,
          value: "12:30",
          ctime: "12:30",
        },
        { label: "13:00-13:30", disable: false, value: "13:00", ctime: "13" },
        {
          label: "13:30-14:00",
          disable: false,
          value: "13:30",
          ctime: "13:30",
        },
        { label: "14:00-14:30", disable: false, value: "14:00", ctime: "14" },
        {
          label: "14:30-15:00",
          disable: false,
          value: "14:30",
          ctime: "14:30",
        },
        { label: "15:00-15:30", disable: false, value: "15:00", ctime: "15" },
        {
          label: "15:30-16:00",
          disable: false,
          value: "15:30",
          ctime: "15:30",
        },
        { label: "16:00-16:30", disable: false, value: "16:00", ctime: "16" },
        {
          label: "16:30-17:00",
          disable: false,
          value: "16:30",
          ctime: "16:30",
        },
        { label: "17:00-17:30", disable: false, value: "17:00", ctime: "17" },
        {
          label: "17:30-18:00",
          disable: false,
          value: "17:30",
          ctime: "17:30",
        },
        { label: "18:00-18:30", disable: false, value: "18:00", ctime: "18" },
        {
          label: "18:30-19:00",
          disable: false,
          value: "18:30",
          ctime: "18:30",
        },
        { label: "19:00-19:30", disable: false, value: "19:00", ctime: "19" },
        {
          label: "19:30-20:00",
          disable: false,
          value: "19:30",
          ctime: "19:30",
        },
        { label: "20:00-20:30", disable: false, value: "20:00", ctime: "20" },
        {
          label: "20:30-21:00",
          disable: false,
          value: "20:30",
          ctime: "20:30",
        },
        { label: "21:00-21:30", disable: false, value: "21:00", ctime: "21" },
        {
          label: "21:30-22:00",
          disable: false,
          value: "21:30",
          ctime: "21:30",
        },
        { label: "22:00-22:30", disable: false, value: "22:00", ctime: "22" },
        {
          label: "22:30-23:00",
          disable: false,
          value: "22:30",
          ctime: "22:30",
        },
        { label: "23:00-23:30", disable: false, value: "23:00", ctime: "23" },
        {
          label: "23:30-24:00",
          disable: false,
          value: "23:30",
          ctime: "23:30",
        },
      ],
      selectedTime: [],
      timeList: [],
      dayMonth: moment(new Date()).format("YYYY-MM-DD"),
      originalDisableStatus: [],
      copyOptions: [],
      treeList: [],
    };
  },
  watch: {},
  mounted() {
    this.user = JSON.parse(localStorage.getItem("store"));
    this.getList();
    // this.getTree()
  },
  methods: {
    //获取部门
    getTree() {
      api.userDirectory().then((data) => {
        // this.treeList = data.data;
        const inflatedData = uncompress(data.data);
        this.treeList = inflatedData;
      });
    },
    //获取预约详情
    getList() {
      const {
        ctimeMenuList,
        // startTime,
        // endTime,
        cText,
        valueMonth,
        urlName,
        urlId,
        userNa,
        userID,
        type,
        time,
      } = this.$route.query;

      this.formList = ctimeMenuList;
      if (type == "1") {
        // this.st = JSON.parse(JSON.stringify(startTime));
        // this.en = JSON.parse(JSON.stringify(endTime));
        // this.formList.region = `${cText}${this.checkDate(
        //   valueMonth
        // )}${this.formatTime(`${this.st}-${this.en}`)}`;
        this.formList.namelist = "";
      } else if (type == "2") {
        this.formList.region = `${cText}${this.checkDate(valueMonth)}${time}`;
        // this.getApprovalDetail();
        if (userID && userNa) {
          let userIds = userID.split(",");
          let nicknames = userNa.split(",");
          let usernames = [];
          for (let i = 0; i < userIds.length; i++) {
            usernames.push({
              username: userIds[i],
              nickname: nicknames[i],
            });
          }
          this.userNames = usernames;
          this.formList.namelist = userNa;
          this.formList.idlist = userID;
          console.log(this.userNames, "this.userNames");
        }
      }
      this.formList.urlName = urlName;
      this.formList.type = type;
      this.formList.urlId = urlId;
      this.formList.name = this.user.userInfo?.nickname;
      if (valueMonth == this.dayMonth) {
        const hh = moment(new Date()).format("H:mm");
        this.generateTimeList(hh);
      } else {
        this.generateTimeList("0:0");
      }

      console.log(ctimeMenuList, "ctimeMenuList");
    },
    // 替换中文标点符号为英文标点符号
    replaceChinesePunctuation(str) {
      // 先将中文顿号替换为中文逗号
      let replacedComma = str.replace(/、/g, "，");
      // 再将中文逗号替换为英文逗号
      return replacedComma.replace(/，/g, ",");
    },
    // 将时间字符串转换为HH:MM格式
    formatHH(timeStr) {
      if (timeStr.includes(":")) {
        // 如果包含冒号，则直接返回原字符串
        return timeStr;
      } else {
        // 如果不包含冒号，则认为是只有小时的数字
        // 将小时转换为数字，确保小时为两位数
        let hour = parseInt(timeStr, 10);
        // 使用模板字符串和padStart方法确保小时为两位数
        // 然后添加':00'作为分钟
        return `${hour.toString().padStart(2, "0")}:00`;
      }
    },
    //获取审批人和抄送人
    getApprovalDetail() {
      api
        .getApprovalDetail({ approveNumber: this.formList.approveNumber })
        .then((data) => {
          console.log(data, "data");
          this.approver = data.data.data.approver;
          this.appmake = data.data.data.notifyer;
          this.appPeople = true;
        });
    },
    //返回
    cancel() {
      this.$router.back();
    },
    // 提交
    submit() {
      if (this.formList.type == "1" && this.selectedTime.length < 1) {
        this.$message({
          type: "warning", // success error warning
          message: "请选择预约时间",
          duration: 2000,
        });
      } else {
        let params = {
          activityRoomId: this.formList.urlId,
          activityAreaId: this.formList.activityAreaId,
          scheduledDate: this.formList.scheduledDate,
          scheduledTime:
            this.formList.type == "2"
              ? this.formList.time
              : this.convertToTimeString(this.selectedTime),
          joinUserName: this.formList.namelist
            ? this.replaceChinesePunctuation(this.formList.namelist)
            : "",
          joinUser: this.formList.idlist
            ? this.replaceChinesePunctuation(this.formList.idlist)
            : "",
          id: this.formList.type == "2" ? this.formList.id : "",
        };
        this.btnLoading = true;
        console.log(params, "params");
        api
          .addOrUpdate(params)
          .then((data) => {
            console.log(data, "data");
            this.$emit("update:visible", false);
            this.$emit("changeUpload");
            this.userNames = [];
            this.userNamesTwo = [];
            this.btnLoading = false;
            this.$router.back();
          })
          .finally(() => (this.btnLoading = false));
      }
    },
    //选择预订时间
    handleChange(event) {
      console.log(this.copyOptions, "this.copyOptions");
      let indexList = []
      if (event.length < 1) {
        this.originalDisableStatus = [];
        for (let i = 0; i < this.options.length; i++) {
          this.options[i].disable = this.copyOptions[i];
        }
      } else {
        const selectedIndex = this.options.findIndex(
          (option) => option.label === event[event.length - 1]
        );
        event.length > 0 && event.forEach(item=>{
          this.options.forEach((list,ind)=>{
            if(item == list.label){
              indexList.push(ind)
            }
          })
        })
        console.log(indexList,'indexList');
        this.originalDisableStatus = [
          ...indexList,
          this.copyOptions[selectedIndex - 1] == false && Math.min(...indexList) - 1,
          this.copyOptions[selectedIndex + 1] == false && Math.max(...indexList) + 1
        ]
        // this.originalDisableStatus.push(
        //   this.copyOptions[selectedIndex - 1] == false && selectedIndex - 1,
        //   selectedIndex,
        //   this.copyOptions[selectedIndex + 1] == false && selectedIndex + 1
        // );
        const indices = [];
        for (let i = 0; i < this.options.length; i++) {
          indices.push(i);
          this.options[i].disable = false;
        }
        const uniqueArray = [...new Set(this.originalDisableStatus)];

        indices.forEach((item) => {
          if (uniqueArray.length > 0 && !uniqueArray.includes(item)) {
            this.options[item].disable = true;
          }
        });
        console.log(uniqueArray, "uniqueArray");
        console.log(this.selectedTime, "this.selectedTime");
      }
    },
    //改变搜索
    changeQuery(val) {
      console.log(val, "valvalval");
      let str = [];
      let id = [];
      this.userNames = [];
      val.length > 0 &&
        val.forEach((item) => {
          str.push(item.nickname);
          id.push(item.username);
          this.userNames.push(item);
        });
      this.formList.namelist = str.join("、");
      this.formList.idlist = id.join("、");
    },
    changeQueryTwo(val) {
      let str = [];
      this.userNamesTwo = [];
      val.length > 0 &&
        val.forEach((item) => {
          str.push(item.nickname);
          this.userNamesTwo.push(item);
        });
      // this.formList.namelist = str.join('、')
    },
    // 将时间范围转换为字符串
    convertToTimeString(ranges) {
      if (ranges.length === 0) return "";

      if (ranges.length === 1) {
        return ranges[0];
      }

      // 提取第一个时间段的起始时间
      const startTime = ranges[0].split("-")[0];

      // 提取最后一个时间段的结束时间
      const endTime = ranges[ranges.length - 1].split("-")[1];

      return `${startTime}-${endTime}`;
    },
    // getList() {
    //   this.list.forEach((item) => {
    //     item.checkDate = this.checkDate(moment(item.date).format("YYYY-MM-DD"));
    //     item.date = moment(item.date).format("MM月DD日");
    //     item.time = this.formatTime(item.time);
    //   });
    // },
    // 处理禁用时间范围
    disableTimeRanges(disableRanges) {
      if (disableRanges) {
        console.log('111');
        let disableTimes = new Set();

        disableRanges.forEach((range) => {
          const [start, end] = range.split("-");
          disableTimes.add(start);
          let currentTime = this.incrementTime(start);
          while (currentTime !== end) {
            disableTimes.add(currentTime);
            currentTime = this.incrementTime(currentTime);
          }
          if (start !== end) disableTimes.add(end);
        });

        const endTimes = disableRanges
          .map((range) => range.split("-")[1]?.trim())
          .filter((time) => time);

        const newList = Array.from(disableTimes).filter(
          (item) => !endTimes.includes(item)
        );

        this.options.forEach((option) => {
          if (newList.includes(option.ctime)) {
            option.disable = true;
          }
        });
      }
    },
    // 增加时间
    incrementTime(time) {
      const [hours, minutes] = time.split(":").map(Number);
      if (minutes === 30) {
        return `${hours + 1}`;
      }
      return `${hours}:30`;
    },
    generateTimeList(timeStr) {
      // 将时间字符串转换为小时和分钟
      const [hours, minutes] = timeStr.split(":").map(Number);

      // 初始化结果数组
      this.timeList = [];

      // 遍历从0到小时数（包含）
      for (let i = 0; i <= hours; i++) {
        // 添加整点时间（以单个数字表示）
        this.timeList.push(i.toString());

        // 如果不是最后一小时，或者最后一小时且分钟数大于等于30，则添加半点时间
        if (i < hours || (i === hours && minutes >= 30)) {
          this.timeList.push(`${i}:30`);
        }
        // 注意：如果最后一小时且分钟数小于30，则不添加该小时的半点时间
      }
      const list = JSON.parse(JSON.stringify(this.formList.timeList));
      let str = list && list.map((item) => item.result); // 提取结果
      const formattedArray =
        str && str.map((times) => `${times[0]}-${times[1]}`); // 格式化

      console.log(formattedArray,'formattedArray');
      this.disableTimeRanges(formattedArray);
      this.options = this.options.filter(
        (item) => !this.timeList.includes(item.ctime)
      );
      // this.options.forEach((item) => {
      //   if (this.timeList.includes(item.ctime)) {
      //     item.disable = true;
      //   }
      // });

      this.copyOptions = this.options.map((option) => option.disable);

      // return this.timeList;
    },

  //转换时间
    checkDate(time) {
      const inputMoment = moment(time);
      const now = moment();
      const daysDiff = inputMoment.diff(now, "days");
      const weekDayNum = inputMoment.day();
      const weekDaysShort = [
        "周日",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六",
      ];
      const day = weekDaysShort[weekDayNum];
      let textToday;

      if (inputMoment.isSame(now, "day")) {
        textToday = `今天(${day})`;
      } else if (daysDiff == 0) {
        textToday = `明天(${day})`;
      } else if (daysDiff == 1) {
        textToday = `后天(${day})`;
      } else if (daysDiff >= 2) {
        textToday = `(${day})`;
      } else {
        textToday = "已过期";
      }
      return textToday;
    },
    //格式化时间
    formatTime(timeRange) {
      const [start, end] = timeRange.split("-");
      const [startHour, startMinute = "00"] = start.split(":");
      const [endHour, endMinute = "00"] = end.split(":");

      const formattedStart = `${startHour.padStart(
        2,
        "0"
      )}:${startMinute.padStart(2, "0")}`;
      const formattedEnd = `${endHour.padStart(2, "0")}:${endMinute.padStart(
        2,
        "0"
      )}`;

      return `${formattedStart}-${formattedEnd}`;
    },
    //点击参与人
    changeDep() {
      console.log("111");
      this.depamentDialog = true;
    },
    //关闭弹窗
    beforeClose(done) {
      this.userNames = [];
      this.userNamesTwo = [];
      this.$emit("update:visible", false);
      done();
    },
    //刷新数据
    finished() {
      this.$emit("update:visible", false);
      this.$emit("changeUpload");
    },
  },
};
</script>

<style lang="scss" scoped>
.submitBox {
  width: 100vw;
  height: 100vh;
  padding: 20px;
  position: relative;
}
.item {
  // background: rgb(235, 232, 232);
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 20px;
}
.changePop {
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  padding-left: 20px;
  color: #dcdfe6;
}
.changePop1{
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  padding-left: 20px;
  color: #6b6b6b;
}
.item:hover {
  background: rgb(235, 232, 232);
}
.item_one {
  // margin-top: -30px;
  font-weight: bold;
  font-size: 24px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-dropdown {
    font-size: 28px;
  }
}
.item_two {
  margin: 15px 0;
  font-size: 23px;
}
.item_three {
  margin: 15px 0;
  font-size: 23px;
}
.menu {
  width: 100%;
  height: 1px;
  background: #ccc;
  margin-bottom: 25px;
}
.choose {
  font-size: 24px;
  // margin-bottom: 20px;
}
.appPeople {
  margin: 20px 0 25px;
  font-size: 28px;
}
.app_item {
  display: flex;
  align-items: center;
}
.approve {
  background: rgb(241, 240, 240);
  padding: 15px 20px;
  font-size: 20px;
  border-radius: 7px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
.makePeople {
  margin: 20px 0 25px;
}
.makeItem {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .iconPlus {
    background: rgb(195, 230, 247);
    padding: 15px 30px;
    border-radius: 7px;
    // margin-left: 10px;
    color: rgb(56, 171, 224);
  }
}
.make {
  background: rgb(241, 240, 240);
  padding: 15px 20px;
  font-size: 20px;
  border-radius: 7px;
  margin-right: 15px;
  display: flex;
  align-items: center;
  img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  bottom: 40px;
  left: 0;
  width: 100vw;
}
.submit {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cancelBtn {
  color: rgba(50, 106, 251, 1);
  border: 1px solid rgba(50, 106, 251, 1);
  background: none;
  width: 200px !important;
  height: 65px !important;
  border-radius: 100px;
  margin-right: 20px;
}
.submitBtn {
  color: #fff;
  background: rgba(50, 106, 251, 1);
  border: 1px solid rgba(50, 106, 251, 1);
  width: 200px !important;
  height: 65px !important;
  border-radius: 100px;
}
::v-deep {
  .el-dialog__body {
    padding: 20px 40px 20px !important;
    height: auto !important;
    overflow: auto;
    position: relative;
    &::-webkit-scrollbar {
      width: 0px;
      height: 1px;
      background-color: rgba(240, 240, 240, 1);
    }
  }
  .el-dialog {
    // height: 70vh !important;
  }
  .el-select {
    width: 100% !important;
  }
}
</style>
